import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  flex-shrink: 0;
  ${({ theme, hasSpacingTop }) =>
    hasSpacingTop && theme.getFluidSpacing('margin-top', 'section', 0)}
  padding-bottom: env(safe-area-inset-bottom);
`;
